export default __webpack_public_path__ + "static/media/sample.6c0214ef.png";